<template>
    <div class="Propuestas">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :menuActivo="2" :url="url"/>

        <div class="container-fluid pt-3">
            
            <router-link to="/Proyectos" class="notLink">
                <font-icon icon="arrow-circle-left"/> Regresar
            </router-link>
            <Proyecto class="pt-2 pb-3" :idProyecto = idProyecto />
            
            <!--Blog-->
            <div class="pt-3" v-if="collapsePreguntas === '1'">
                <Blog :id=idProyecto :status = status />
            </div>
        </div>

    </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import Submenu from '@/components/Submenu'
import Menu from '@/components/Menu'
import StarRating from 'vue-star-rating'
import Proyecto from '@/components/Proyecto'
import Blog from '@/components/Blog'

export default {
name:'Propuestas',
mixins: [ globalFunctions ],
components:{
    Submenu,Menu,StarRating,Proyecto,Blog
},
data(){
    return(
        {
        idProyecto: this.$route.params.idEmpresa,
        rol: localStorage.rol,
        sesion: false,
        collapsePreguntas:'1',
        collapsePropuestas:'0',
        propuestas:[],
        status: ''
        }
    )
},
methods:{
getPropuestas(){
    
    let data = {
        rol: this.rol,
        id:this.idProyecto,
        idCons: localStorage.userID,
        flag: 0
    }

    this.axios.post(this.url + 'getPropuestas.php', data).then((responce) =>{
        this.propuestas = responce.data;
        this.status = responce.data[0].estatus_oferta;
    });
},
toggle(tipo)
{
    if(tipo == '1')
    {
        this.collapsePropuestas = '0';
        this.collapsePreguntas = '1';
    }else
    {
        this.collapsePropuestas = '1';
        this.collapsePreguntas = '0';
    }
},
},
computed:{
    ...mapState(['url'])
},
mounted(){
    this.getPropuestas();
    let resp = this.checkUser();
    this.sesion = resp;
}
}
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/DetalleProyecto/DetalleProyecto.vue